import React from 'react';

import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material';
import Tooltip from '@material-ui/core/Tooltip';

export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFFFFF',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #D7D7D7',
    borderRadius: 5
  }
}));